import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { storyblokEditable } from '@storyblok/react';
import { memo } from 'react';
import { withBaseComponent } from '../hoc/withBaseComponent';

/**
 * @param {object} props
 * @param {object} props.baseStyles
 */
const StoryblokDividerComponent = ({ blok, baseStyles }) => {
  const { extra = { id: '' } } = blok;
  const { id } = extra;
  return (
    <Box id={id} sx={{ width: '100%', ...baseStyles }} {...storyblokEditable(blok)}>
      <Divider orientation="horizontal" />
    </Box>
  );
};

StoryblokDividerComponent.displayName = 'StoryblokDivider';
const StoryblokDivider = withBaseComponent(StoryblokDividerComponent);

export default memo(StoryblokDivider);
